import { FieldArray } from "formik";
import React from "react";
import { useMessageSource } from "react-message-source";

import TypographyContainer from "../../../ui/layout/page/typography-container/typography-base-container";
import TypographyItemContainer from "../../../ui/layout/page/typography-container/typography-item-container";
import CustomTypography from "../../../ui/widgets/typography";
import { generateComponentUniqueKey } from "../../../util/key-generator";
import GTM from "../../../util/tracking/gtm";
import {
  EventCategory,
  PERSON_ADDED_ACTION_VALUE,
} from "../../../util/tracking/types";
import { emptyPerson } from "../defaults";
import { PersonType, SetNameAndSignatureType } from "../types";
import SignatoryDropDown from "./signatoryDropDown";
import { SignatoryType, SignatureType } from "../../../api/cybwell/types";

export default function OtherThanCardholder({
  signatories,
  firstList,
  secondList,
  setNameAndSignatureType,
}: {
  signatories: PersonType[];
  firstList: SignatoryType[];
  secondList?: SignatoryType[];
  setNameAndSignatureType: SetNameAndSignatureType;
}): React.JSX.Element {
  const { getMessage } = useMessageSource();

  return (
    <FieldArray name={"otherSignatories"}>
      {({ remove, replace }) => (
        <>
          {signatories &&
            signatories.length > 0 &&
            signatories.map((_, index) => {
              return (
                <React.Fragment key={`otherSignatories[${index}]`}>
                  {index === 1 && (
                    <TypographyContainer>
                      <TypographyItemContainer>
                        <CustomTypography variant="body1">
                          {getMessage("Signing.subtitle-second-signing")}
                        </CustomTypography>
                      </TypographyItemContainer>
                    </TypographyContainer>
                  )}
                  <SignatoryDropDown
                    setNameAndSignatureType={setNameAndSignatureType}
                    name={`otherSignatories[${index}]`}
                    signatories={index === 0 ? firstList : secondList}
                    selectedSignatory={signatories[index]}
                    onSelect={
                      index === 0
                        ? (selectedSignature) => {
                            if (
                              selectedSignature.signatureType ===
                              SignatureType.Double
                            ) {
                              replace(1, {
                                id: generateComponentUniqueKey(),
                                ...emptyPerson,
                              });

                              GTM.trackEvent(
                                EventCategory.AuthorizedSignatory,
                                PERSON_ADDED_ACTION_VALUE,
                              );
                            }
                            if (
                              selectedSignature.signatureType ===
                                SignatureType.Single &&
                              signatories.length > 1
                            ) {
                              remove(1); // remove the second signatory
                            }
                          }
                        : null
                    }
                  />
                </React.Fragment>
              );
            })}
        </>
      )}
    </FieldArray>
  );
}
